// extracted by mini-css-extract-plugin
module.exports = {"offer":"HighestOffer_offer__3OQvA","highestOfferContainer":"HighestOffer_highestOfferContainer__88ble"};